var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('span',{staticClass:"text--disabled"},[_vm._v(_vm._s(_vm.currency.toUpperCase()))]),_vm._v("  "),_c('span',{class:_vm.cssClass},[_vm._v(_vm._s(_vm.display))])])
}
var staticRenderFns = []

export { render, staticRenderFns }